<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="换货编号：">
            <el-input v-model="query.orderNum" placeholder="请输入换货编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="售后编码：">
            <el-input v-model="query.afterOrderNum" placeholder="请输入售后编码" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：" width="150px">
            <el-input v-model="query.goodsName" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="query.orderPayType" placeholder="请选择" clearable size="small">
              <el-option label="微信支付" :value="1"></el-option>
              <el-option label="支付宝支付" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.name" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="快递类型：">
            <!-- <el-select v-model="query.deliveryOptions" placeholder="请选择" clearable size="small">
              <el-option label="中通" :value="1"></el-option>
              <el-option label="顺丰" :value="2"></el-option>
            </el-select> -->
            <el-select v-model="query.deliveryOptions" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(it,idx) in deliveryAllList" :key="idx" :label="it.name" :value="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：">
            <el-input v-model="query.logisticsNumber" placeholder="请输入快递单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="支付时间" :value="1"></el-option>
              <el-option label="创建时间" :value="2"></el-option>
              <el-option label="发货时间" :value="3"></el-option>
              <el-option label="完成时间" :value="4"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="exchangeTotal">
          <el-tab-pane :label="'待发货('+ exchangeTotal.pendingShipment +')'" name="2"></el-tab-pane>
          <el-tab-pane :label="'待收货('+ exchangeTotal.pendingReceipt +')'" name="3"></el-tab-pane>
          <el-tab-pane :label="'已完成('+ exchangeTotal.completed +')'" name="4"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="addOrderToYongYou" plain v-hasPermi="['order:changeorder:push']">补推订单</el-button> -->
          <el-button type="primary" size="mini" @click="handleExport" plain v-hasPermi="['order:changeorder:export']">导出</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column :min-width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="item.prop === 'orderNum'" :sortable="item.isSortable" :show-overflow-tooltip="item.showToolTip">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)" v-if="item.prop === 'orderNum'">{{row.orderNum}}</el-link>
            <block v-else-if="item.prop === 'exchangeGoodsList'">
              <span v-for="(it,index) in row.exchangeGoodsList" :key="index">{{it.goodsName}}*{{it.goodsCount}}<span v-if="index<row.exchangeGoodsList.length-1">,</span></span>
            </block>
            <block v-else-if="item.prop === 'addrProvince'">
              <span>姓名:{{row.name}}</span><br />
              <span>手机号:{{row.pho}}</span><br />
              <span v-if="row.addr && row.addr.length > 0">所属区域:
                <span v-for="(item,index) in row.addr" :key="index">{{item.regionName}}</span>
              </span>
            </block>
            <block v-else-if="item.prop === 'customerAddressPO'">
              <template v-if="row.customerAddressPO">
                <span>姓名:{{row.customerAddressPO.customerName}}</span><br />
                <span>手机号:{{row.customerAddressPO.customerPhone}}</span><br />
                <span>收货地址:{{row.customerAddressPO.province}}{{row.customerAddressPO.city}}{{row.customerAddressPO.district}}{{row.customerAddressPO.detailedAddress}}</span>
              </template>
            </block>
            <block v-else-if="item.prop === 'deliveryOptions'">
              {{row.deliveryOptions === 1?'中通快递':(row.deliveryOptions === 2?'顺丰快递':'')}} {{row.logisticsNumber}}
            </block>
            <block v-else-if="item.prop === 'repairMoney'">
              {{row.payType === 1?'微信：':(row.payType === 2?'支付宝：':'')}} {{row.repairMoney}}
            </block>
            <block v-else-if="item.prop === 'operatePO'">
              {{row.operatePO.createdBy}}
            </block>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="130" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleLogistics(row)" v-if="+activeName === 3 || +activeName === 4" v-hasPermi="['order:changeorder:logistics']">查看物流</el-button>
            <el-button type="text" @click="tuiOrder(row)" v-if="+activeName === 2" v-hasPermi="['order:changeorder:push']">补推订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
    <logistics-vue ref="logisticsVue" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import Pagination from '@/components/Pagination'
import changeFieldsVue from '@/views/common/changeFields.vue'
import logisticsVue from '@/views/common/logistics.vue'
export default {
  components: {
    Pagination, changeFieldsVue, logisticsVue
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNum: undefined,
        afterOrderNum: undefined,
        goodsName: undefined,
        orderPayType: undefined,
        name: undefined,
        pho: undefined,
        deliveryOptions: undefined,
        timeType: undefined,
      },
      dateTime: [],
      showMore: true,
      activeName: "2",
      listLoading: false,
      list: [],
      total: 0,
      exchangeTotal: null,
      orderTitle: 2,
      multipleSelection: [],
      allTemplate: [{ label: '换货编号', prop: 'orderNum' }, { label: '售后编码', prop: 'afterOrderNum' },
      { label: '换货商品', prop: 'exchangeGoodsList' ,showToolTip: true, width: '160px'}, { label: '换货商品总数', prop: 'totalCount' },
      { label: '申请人信息', prop: 'addrProvince', width: '170px' }, { label: '收货地址', prop: 'customerAddressPO', width: '170px' }, { label: '补差金额', prop: 'repairMoney', width: '120px' },
      { label: '支付时间', prop: 'payTime', width: '160px' }, { label: '创建时间', prop: 'createdTime', width: '160px' },
      { label: '发货时间', prop: 'sendTime', width: '160px' }, { label: '完成时间', prop: 'finishTime', width: '160px' },
      { label: '快递信息', prop: 'deliveryOptions' }, { label: '操作时间', prop: 'operatedTime', width: '160px' }, { label: '操作人', prop: 'operatePO' }],
      dynamicHeaders: [],
      deliveryAllList: []
    };
  },
  created() {
    let { name } = this.$route.query;
    if (name) this.query.name = name
    this.doQueryList({})
    this.getFieled();
    this.getAllDeliveryList()
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    handleLogistics(row) {
      this.$refs.logisticsVue.handleLogistics(row.deliveryList)
    },
    getAllDeliveryList() {
      goodsOrderApi.getDeliveryList({ isEnable: true }).then(res => {
        let { list } = res.data;
        this.deliveryAllList = list;
      })
    },
    getFieled() {
      if (localStorage.getItem('changeTableColumn')) {
        let tColumn = JSON.parse(localStorage.getItem('changeTableColumn'))
        this.dynamicHeaders = tColumn
      } else {
        this.dynamicHeaders = this.allTemplate
      }
      console.log(this.dynamicHeaders)
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      console.log(newL)
      localStorage.setItem('changeTableColumn', JSON.stringify(newL))
    },
    getAfterTotalNum() {
      let params = JSON.parse(JSON.stringify(this.query));
      delete params.state
      delete params.pageNo
      delete params.pageSize
      goodsOrderApi.getExchangeTotal(params).then((res) => {
        let { data } = res;
        if (!data) {
          let obj = {
            pendingShipment: 0,
            pendingReceipt: 0,
            completed: 0
          }
          data = obj;
        }
        this.exchangeTotal = data;
      })
    },
    calcQuery() {
      let { timeType } = this.query
      if (timeType && this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      } else {
        this.query.startTime = undefined
        this.query.endTime = undefined
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.getAfterTotalNum()
      this.query.state = +this.activeName
      this.listLoading = true
      return goodsOrderApi.getChangeOrder(this.query).then(res => {
        let { list, total } = res.data;
        list.forEach(item => {
          item.operatedTime = item.operatePO && item.operatePO.operatedTime
        })
        this.list = list;
        this.total = total;
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleFilter() {
      this.query = {};
      this.dateTime = [];
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 点击搜索
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    // 切换订单类型
    handleClick(e) {
      this.doQueryList({ pageNo: 1 })
    },
    // 补推订单
    selectionChange(val) { this.multipleSelection = val; },
    // addOrderToYongYou() {
    //   let idStr = '';
    //   if (!this.multipleSelection.length) return this.$message({ message: '请选择补推订单!' });
    //   let id = [];
    //   this.multipleSelection.forEach(it => {
    //     id.push(it.id)
    //   })
    //   idStr = id.join(',');
    //   this.$confirm('确定需要补推订单吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     goodsOrderApi.addOrderToYongYou({ idStr }).then((data) => {
    //       this.$message({
    //         type: 'success',
    //         message: '补推订单成功!'
    //       });
    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消补推订单'
    //     });
    //   });

    // },
    // 补推订单
    tuiOrder(row) {
      this.$confirm('确定将本订单再一次推送到聚水潭平台中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.goodsTuiOrder(row);
      }).catch(() => { });
    },
    goodsTuiOrder(row) {
      goodsOrderApi.goodsTuiOrder({ orderid: row.customerOrderId }).then(res => {
        this.$message({ type: 'success', message: '推送成功!' });
      })
    },
    // 导出
    handleCreate() { },
    changeShow() {
      this.showMore = !this.showMore;
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleShow(row) {
      row.activeName = +this.activeName
      this.$emit('handleShow', row, 2)
    },
    // 同意
    handleAddTrackingNumber(row) {
      this.$prompt("是否确认同意该申请？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "成功",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    //驳回
    handleUpOrder(row) {
      this.$confirm("驳回原因：", "驳回申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleExport() {
      this.$router.push("/export/list?code=exchangeOrderExport")
    },
  },
};
</script>
<style>
.block {
  padding: 20px 0;
}
.filter-container .el-input__inner {
  /* width: 200px !important; */
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
